export function safeAssert(value: any, message?: string | Error): asserts value {
  if (value) {
    return;
  }
  if (message instanceof Error) {
    throw message;
  } else {
    throw new Error(message ?? 'Assertion failed');
  }
}

export function safeAssertAll<T>(values: Array<T | undefined>, message?: string | Error): asserts values is T[] {
  for (const value of values) {
    safeAssert(value, message);
  }
}
